const fileExtensions = /\.(doc|docx|pdf|txt|zip|rar|xls|xlsx|ppt|pptx)$/i
const imageExtensions = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i
const videoExtensions = /\.(mp4|mov|avi|mkv|wmv|flv|mpeg|webm)$/i

export const findFileType = (fileName: string) => {
  if (fileExtensions.test(fileName)) return 'file'
  if (imageExtensions.test(fileName)) return 'image'
  if (videoExtensions.test(fileName)) return 'video'

  return undefined
}
